module.exports = __webpack_public_path__ + "img/roar.jpg_w545.538fb3ee.jpg";